<template>
  <div class="table">
    <div class="selected-item" v-if="selection">
      <div class="num">已选择<span>{{ selectedDevices.length }}</span>项</div>
      <div v-if="batchDelete" class="delete" @click="hadeleteAllSelected">删除</div>
      <div v-if="isMark" class="mark" @click="allMark">一键赋分</div>
      <!-- <div v-if="batchDeal" class="deal" @click="dealAllSelected">批量处理</div> -->
    </div>

    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;"
      :height="dyicHeight"
      :row-class-name="isGrenn"
      :cell-style="cellStyle"
      :header-cell-style= 'headerCellStyle'
      @selection-change="selectionChange">
      <el-table-column
        v-if="selection"
        type="selection"
        align="center"
        :selectable="selectedRow"
        width="70">
      </el-table-column>
      <el-table-column
        v-if="index"
        label="序号"
        align="center"
        type="index"
        :index="indexMethod">
      </el-table-column>
      <el-table-column 
        v-for="(info, index) in tableInfo" :key="index"
        :prop="info.key"
        :label="info.name"
        align="center"
        :min-width="info.minWidth"
        :width="info.width"
        :show-overflow-tooltip="!info.hideTooltip"
      >
        <template slot-scope="{row}">
          <slot v-if="info.type === 'custom'" :name="info.key" :scope="row">--</slot>
          <div v-else-if="info.type === 'enum'" class="status" :style="{color: `${info.value[+row[info.key]].color}`}">{{info.value[+row[info.key]].text}}</div>
          <el-switch
            v-else-if="info.type === 'switch'"
            v-model="row[info.key]"
            active-color="#00AF84"
            inactive-color="#A1A8B2"
            @change="info.callback(row)"
            >
          </el-switch>
          <div v-else-if="info.type === 'link' && !row[info.key]">--</div>
          <div v-else-if="info.type === 'link'" class="link-url" @click="info.callback(row[info.key])">点击查看</div>
          <img v-else-if="info.type === 'img' && info.callback" :src="[row[info.key]]" class="img" alt="图片" @click="info.callback(row)">
          <el-image 
            v-else-if="info.type === 'img'"
            style="width: 59px; height: 34px;padding-top: 6px;"
            :src="row[info.key]" 
            :preview-src-list="[row[info.key]]">
          </el-image>
          <span v-else>{{row[info.key]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operate" label="操作" align="center" :min-width="actionWidth" v-if="!hiddenOperate">
        <template slot-scope="{row}">
          <slot name="operate" :scope="row"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  /**
   * index        是否自定义索引
   * selection    是否开启勾选功能
   * hiddenOperate 是否隐藏操作栏
   * disableKey   数据中用来判断不可选中的key
   * batchDelete  批量删除按钮
   * batchDeal    批量处理按钮
   * isMark       一键赋分按钮
   * tableData    table数据
   * tableInfo    table的配置信息
   * - key        字段名称
   * - name
   * - minWidth
   *
   * 类型简介  enum/switch/link
   * - type       custom    自定义样式
   * - type       enum      状态
   * - value      { 0: { text: '未运行', color: '#C3C5C7' }, 1: { text: '运行中', color: '#00AF84' }} 类似这种，设置type后有效
   *
   * - type       switch    开关
   * - callback   callback(row)
   *
   * - type       link      链接
   * - callback   callback(linkUrl)
   *
   * - type       img       图片
   *
   */
  export default {
    props: {
      height: String,
      batchDelete: {
        type: Boolean,
        default: true
      },
      isMark: {
        type: Boolean,
        default: false
      },
      batchDeal: {
        type: Boolean,
        default: false
      },
      index: {
        type: Boolean,
        default: false
      },
      selection: {
        type: Boolean,
        default: false
      },
      disableKey: {
        type: String,
        default: ''
      },
      tableInfo: {
        type: Array,
        default () {
          return []
        }
      },
      tableData: {
        type: Array,
        default () {
          return []
        }
      },
      hiddenOperate: {
        type: Boolean,
        default: false
      },
      actionWidth: {
        type: [Number, String],
        default: 120
      },
      pagination: {
        type: Object,
        default () {
          return {}
        }
      },
      hideTooltip: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        selectedDevices: []
      }
    },
    watch: {
      tableData (newV, oldV) {
        if (newV !== oldV) {
          this.selectedDevices = []
          this.$emit('selectedRows', [])
        }
      }
    },
    computed: {
      dyicHeight () {
        return this.height ? this.height : this.selection ? 'calc(100% - 70px)' : '100%'
      }
    },
    methods: {
      indexMethod (index) {
        const { currentPage = 0, pageSize = 0 } = this.pagination
        if (currentPage === 0) {
          return index + 1
        } else {
          return (currentPage - 1) * pageSize + index + 1
        }
      },
      selectedRow (row) {
        if (!this.disableKey) return true
        return !row[this.disableKey]
      },
      isGrenn ({ row }) {
        const checkIdList = this.selectedDevices.map((item) => item.id)
        if (checkIdList.includes(row.id)) {
          return 'row-style'
        }
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      selectionChange (devices) {
        this.selectedDevices = devices
        this.$emit('selectedRows', devices)
      },
      hadeleteAllSelected () {
        if (!this.selectedDevices.length) {
          this.$message.warning('请选择要删除的项！')
          return
        }
        this.$emit('deleteList', this.selectedDevices)
      },
      allMark () {
        if (!this.selectedDevices.length) {
          this.$message.warning('请选择要赋分的项！')
          return
        }
        this.$emit('allMark', this.selectedDevices)
      },
      dealAllSelected () {
        if (!this.selectedDevices.length) return
        this.$emit('dealList', this.selectedDevices)
      },
      headerCellStyle ({row, rowIndex, columnIndex}) {
        return {background: '#F3F3F3', fontWeight: 600, fontFamily: 'MiSans', color: '#464C5E'}
      },
      cellStyle ({ row, rowIndex, columnIndex }) {
        return {background: '#ffffff', fontWeight: 400, fontFamily: 'MiSans', color: '#464C5E'}
      }
    }
  }
</script>
<style lang="scss" scoped>
.table {
  height: 100%;
  font-size: 14px;
}
.status {
  font-size: 14px;
  font-family: MiSans;
  font-weight: 400;
}
.link-url {
  font-size: 14px;
  font-family: MiSans;
  font-weight: 400;
  text-decoration: underline;
  color: #00AF84;
  cursor: pointer;
}
.img {
  width: 70px;
  height: 40px;
  cursor: pointer;
}

::v-deep .el-table{
   border-left: 1px solid #eee;
   border-right: 1px solid #eee;

  display: flex;
  flex-direction: column;
  // .el-table__header-wrapper {
    // overflow: visible !important;
  // }
}
::v-deep .el-table tbody tr:hover>td { background-color: #00af841a !important}
//  或
// ::v-deep .el-table__body-wrapper tbody tr:hover>td{ background-color: #00af841a !important}
::v-deep .el-table th.el-table__cell > .cell {
  font-size: 14px;
}
::v-deep .el-table td.el-table__cell > .cell {
  font-size: 14px;
}
::v-deep .el-table .el-table__header .el-table__cell {
  height: 36px;
}
::v-deep .el-table .el-table__cell {
  height: 48px;
  padding: 5px 0;
}
::v-deep .el-table .cell.el-tooltip {
  min-width: 80px !important;
}
.selected-item {
  display: flex;
  align-items: center;
  padding: 12px 0 12px 27px;
  font-size: 14px;
  font-family: MiSans;
  font-weight: 400;
  color: #464C5E;
  background: rgba(0,175,132,0.0500);
  border: 1px solid rgba(0, 175, 132, .3);
  border-radius: 4px;
  margin-bottom: 10px;
  .num {
    span {
      color: #00AF84;
    }
  }
  .delete, .deal, .mark {
    color: #00AF84;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
<style>
.el-tooltip__popper{ max-width:400px }
</style>
